BookingChangeDate.$inject = [
  '$uibModalInstance',
  'Club',
  'moment',
  'alerts',
  'Time',
  'serverDateTimeFormat',
  'ngModel',
  'deps',
  'booking',
  'User'
];

/* @ngInject */
function BookingChangeDate(
  $uibModalInstance,
  Club,
  moment,
  alerts,
  Time,
  serverDateTimeFormat,
  ngModel,
  deps,
  booking,
  User
) {
  this.court = { ...booking.court };

  const isFixed = booking.attrs.fixed ? true : false;

  this.loading = true;
  this.courts = [];

  this.selectedCourt = { id: booking.court.id, name: booking.court.name };
  this.day = ngModel.day;

  const dateAux = ngModel.date;

  this.hour = dateAux.format("HH:mm");
  this.date = dateAux;

  this.start = booking.attrs.start.toStringFormalized();

  this.bookingDate = moment(dateAux).toDate();

  let eventDate = moment(dateAux).startOf('day');
  let now = moment().startOf('day');
  let diffDays = eventDate.diff(now, 'days');

  this.canEdit = !isFixed || isFixed && (diffDays >= 0 && diffDays < 7);

  this.disabled = function ({ date, mode }) {
    return (mode === 'day' && (moment(date).weekday() !== moment(dateAux).weekday()));
  };

  let today = moment();
  while (today.weekday() != eventDate.weekday()) {
    today.add(1, 'days');
  }
  this.validDate = today.format('DD-MM-YYYY');

  this.dateOptions = {
    initDate: this.bookingDate,
    formatYear: "yy",
    minDate: moment().startOf("day"),
    startingDay: 1,
    showWeeks: false,
    // dateDisabled: this.disabled,
  };

  Club.API.customGET("courts_from_sport/" + booking.attrs.sport.id)
    .then((courts) => {
      this.loading = false;
      this.courts = courts.map((court) => ({ id: court.id, name: court.name, state: court.state, sportclub_id: court.sportclub_id })).filter(c => c.state === 2).filter(c => c.sportclub_id === Club.id);
    })
    .catch((response) => {
      alerts.errorHandler(response);
    });

  this.dynamic_duration = {
    model: (() => {
      var d = new Time.Hour();
      d.hour = booking.attrs.start.hour;
      d.min = booking.attrs.start.min;
      return d.toDate();
    })(),
    changed: function () {
      var d = this.model;
      this.duration_custom = d.getHours() * 60 + d.getMinutes();
    },
  };

  this.clearDate = () => this.bookingDate = '';

  this.canUpdateCourt = () => {
    return true;
  };

  this.updateCourt = () => {
    var d = this.dynamic_duration.model;

    alerts
        .verifyCode(null, null, User)
        .then(
            updateCourt.bind(null, {
                booking_id: booking.id,
                is_done: booking.done ? true : false,
                court_id: this.selectedCourt.id,
                datetime: moment(this.bookingDate)
                    .set({ hour: d.getHours(), minute: d.getMinutes() })
                    .format('YYYY-MM-DD HH:mm'),
            }),
        )
        .catch((error) => {
            alerts.errorHandler(error);
        });
  };

  this.close = () => {
    $uibModalInstance.close(true);
  };

  function updateCourt(data, {code}) {
    data.code = code;
    booking
      .api()
      .one("check_overlap")
      .customPOST(data)
      .then(function (res) {
        alerts.success(
          "¡Exito!",
          "Se ha actualizado el evento correctamente"
        );
        $uibModalInstance.close(true);
        deps.refresh();
      })
      .catch(alerts.errorHandler)
      .finally(function () { });
  }
}

BookingChangeDateModal.$inject = [
  '$uibModal',
];



function BookingChangeDateModal($uibModal) {
  return {
    open: function ({ booking, deps, ngModel }, { onUpdated } = {}) {
      $uibModal.open({
        template: require('./booking-change-date.component.html'),
        size: 'sm',
        backdrop: true,
        bindToController: true,
        controller: BookingChangeDate,
        controllerAs: 'vm',
        windowClass: 'zindex',
        resolve: {
          deps,
          ngModel,
          booking,
          onUpdated: () => onUpdated,
        }
      });
    }
  };
}

export default BookingChangeDateModal;